module.exports = __webpack_public_path__ + "static/youtube-07b8560a6a6eb7155b80b0c599e6874e.png";